import React from "react";
import "./CommonPageHeader.css";

/**
 * Page header bar: icon + title/description on the left; optional actions on the right.
 * Pass `onBack` to show a secondary-style Back control on the far right (after `rightContent` when both are set).
 */
const CommonPageHeader = ({
  barClassName,
  contentClassName,
  leftClassName,
  iconWrapperClassName,
  textClassName,
  titleClassName,
  descriptionClassName,
  rightClassName,
  icon,
  title,
  titleSuffix,
  description,
  rightContent,
  onBack,
  backLabel,
  backButtonClassName,
}) => {
  const showRight = Boolean(rightContent) || typeof onBack === "function";
  const backText = backLabel != null && backLabel !== "" ? backLabel : "Back";

  return (
    <div className={["common-page-header-bar", barClassName].filter(Boolean).join(" ")}>
      <div className={["common-page-header-content", contentClassName].filter(Boolean).join(" ")}>
        <div className={["common-page-header-left", leftClassName].filter(Boolean).join(" ")}>
          <div className={["common-page-header-icon-wrapper", iconWrapperClassName].filter(Boolean).join(" ")} aria-hidden>
            {icon}
          </div>
          <div className={["common-page-header-text", textClassName].filter(Boolean).join(" ")}>
            {titleSuffix ? (
              <div className="common-page-header-title-row">
                <h1 className={["common-page-header-title", titleClassName].filter(Boolean).join(" ")}>{title}</h1>
                {titleSuffix}
              </div>
            ) : (
              <h1 className={["common-page-header-title", titleClassName].filter(Boolean).join(" ")}>{title}</h1>
            )}
            {description ? (
              <p className={["common-page-header-description", descriptionClassName].filter(Boolean).join(" ")}>
                {description}
              </p>
            ) : null}
          </div>
        </div>
        {showRight ? (
          <div className={["common-page-header-right", rightClassName].filter(Boolean).join(" ")}>
            {rightContent}
            {typeof onBack === "function" ? (
              <button
                type="button"
                className={["common-page-header-back-btn", backButtonClassName].filter(Boolean).join(" ")}
                onClick={onBack}
                aria-label={backText}
              >
                <span className="common-page-header-back-arrow" aria-hidden>
                  ←
                </span>
                <span className="common-page-header-back-text">{backText}</span>
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

CommonPageHeader.defaultProps = {
  barClassName: "documents-header-bar",
  contentClassName: "documents-header-content",
  leftClassName: "documents-header-left",
  iconWrapperClassName: "documents-header-icon-wrapper",
  textClassName: "documents-header-text",
  titleClassName: "documents-page-title",
  descriptionClassName: "documents-page-description",
  rightClassName: "documents-header-right",
  titleSuffix: null,
  description: "",
  rightContent: null,
  onBack: undefined,
  backLabel: undefined,
  backButtonClassName: "",
};

export default CommonPageHeader;
